module.exports = __webpack_public_path__ + "assets/images_base/straits-times-logo.svg?v=8910387e";